export default __webpack_public_path__ + "static/media/airtank-4.19847ca0.svg";